/*
 * Copyright (c) 2024 Ask Sage, Inc. All rights reserved.
 * This software is the confidential and proprietary information of Ask Sage, Inc.
 * You shall not disclose such confidential information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Ask Sage, Inc.
 * THIS SOFTWARE IS PROVIDED "AS IS" AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL ASK SAGE, INC.
 * OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
 * OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * You may not use this software except in compliance with the License.
 * You may not modify, reverse engineer, or redistribute this software.
 */
import React, { useState, useEffect } from 'react';
import * as default_data from '../config.js'
import WorkbookList from './Workbook/WorkbookList.js';
import Workbook from './Workbook.js';
import { getWithExpiry, isBotLoggedIn, getUser } from '../AuthService.js'
import { useTheme } from '@mui/material';
import { Navbar } from '../Chat/Navbar.js';

const Home = () => {

  const [workbook, setWorkbook] = useState(null);

  const [paid, setPaid] = useState(false);
  const [cur_user, setUser] = useState(null);

  const [loaded, setLoaded] = useState(false);
  var loaded_static = false;
  const theme = useTheme();

  useEffect(() => {
    if (loaded || loaded_static) {
      return;
    }

    setLoaded(true)
    loaded_static = true;

    if (getWithExpiry('loss-pass') === true) {
      window.location = '/update?action=force_password';
      return;
    }
    var user = getUser()

    setPaid(user.paid)
    if (user.paid === false) {
      window.location = '/payment';
      return;
    }

    setUser(user)
  }, [])

  function handleWorkbookClick(workbook) {
    setWorkbook(workbook);
  }

  return (
    workbook === null ?
      <div className="AppContainer" style={{
        display: 'flex',
        flexDirection: 'row',
        height: '100vh',
        width: '100vw',
        overflow: 'hidden',
        backgroundColor: theme.palette.appBackground,
      }}>

        <Navbar/>
        <div 
          style={{
            width: 'calc(100vw - 50px)',
            height: '100%',
          }} 
          className={
            `${((paid != true && default_data.default_customer_tenant !== true) || (cur_user && cur_user.plan_type && cur_user.plan_type === 'trial')) ? 'longer' : ''} ${isBotLoggedIn() ? 'bot' : ''}`
          }
        >
          <WorkbookList handleWorkbookClick={handleWorkbookClick} />
        </div>
      </div> :
      <Workbook workbook={workbook} />
  );
}

export default Home;